export default function moduleFactory(Module, selector, options = {}) {
  const elements = Array.from(document.querySelectorAll(selector));

  return elements.map((element) => new Module(element, options));
}
